import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getCloserLocations = async (params) => {
    const defaultResult = []

    try {
      const {body} = await Api.post(`/closerLocation/list`, params)
      if (!body.error && body.cloaserLocations && Array.isArray(body.cloaserLocations)) {
        return body.cloaserLocations
      } else {
        return defaultResult
      }
    } catch (error) {
      return defaultResult
    }
  }
}
